import { render, staticRenderFns } from "./KnowledgeUnitMoveView.vue?vue&type=template&id=344aa8e4&"
import script from "./KnowledgeUnitMoveView.vue?vue&type=script&lang=js&"
export * from "./KnowledgeUnitMoveView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports